module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 9-64414fcbc43054b22a66dba3d4ce2cae.png";